export const Supplier = [
  {
    pernil: {
      fornecedorA: {
        minQuant: 2000 + " Kg",
        precoBase: 12.0,
        leadTime: 7 + " Dias",
        atraso: 7 + " Dias",
        confiabilidade: 95 + "%",
        desconto: 0 + "%",
      },
      fornecedorB: {
        minQuant: 5000 + " Kg",
        precoBase: 10.0,
        leadTime: 14 + " Dias",
        atraso: 7 + " Dias",
        confiabilidade: 80 + "%",
        desconto: 2 + "%",
      },
      fornecedorC: {
        minQuant: 20000 + " Kg",
        precoBase: 8.0,
        leadTime: 14 + " Dias",
        atraso: 7 + " Dias",
        confiabilidade: 70 + "%",
        desconto: 4 + "%",
      },
    },
  },
  {
    frangoLeve: {
      fornecedorA: {
        minQuant: 24000 + " Kg",
        precoBase: 4.65,
        leadTime: 7 + " Dias",
        atraso: 7 + " Dias",
        confiabilidade: 95 + "%",
        desconto: 0 + "%",
      },
      fornecedorB: {
        minQuant: 24000 + " Kg",
        precoBase: 4.65,
        leadTime: 7 + " Dias",
        atraso: 14 + " Dias",
        confiabilidade: 80 + "%",
        desconto: 1 + "%",
      },
    },
  },
  {
    frangoPesado: {
      fornecedorA: {
        minQuant: 12000 + " Kg",
        precoBase: 4.7,
        leadTime: 7 + " Dias",
        atraso: 7 + " Dias",
        confiabilidade: 95 + "%",
        desconto: 0 + "%",
      },
      fornecedorB: {
        minQuant: 12000 + " Kg",
        precoBase: 4.7,
        leadTime: 7 + " Dias",
        atraso: 14 + " Dias",
        confiabilidade: 80 + "%",
        desconto: 1 + "%",
      },
    },
  },
  {
    sacola: {
      fornecedorA: {
        minQuant: 4000 + " Milheiro",
        precoBase: 350.0,
        leadTime: 7 + " Dias",
        atraso: 7 + " Dias",
        confiabilidade: 95 + "%",
        desconto: 0 + "%",
      },
      fornecedorB: {
        minQuant: 4000 + " Milheiro",
        precoBase: 350.0,
        leadTime: 7 + " Dias",
        atraso: 14 + " Dias",
        confiabilidade: 80 + "%",
        desconto: 8 + "%",
      },
      fornecedorC: {
        minQuant: 600 + " Milheiro",
        precoBase: 350.0,
        leadTime: 14 + " Dias",
        atraso: 7 + " Dias",
        confiabilidade: 70 + "%",
        desconto: 12 + "%",
      },
    },
  },
  {
    batata: {
      fornecedorA: {
        minQuant: 24000 + " Kg",
        precoBase: 4.5,
        leadTime: 7 + " Dias",
        atraso: 7 + " Dias",
        confiabilidade: 95 + "%",
        desconto: 0 + "%",
      },
      fornecedorB: {
        minQuant: 24000 + " Kg",
        precoBase: 4.5,
        leadTime: 7 + " Dias",
        atraso: 14 + " Dias",
        confiabilidade: 80 + "%",
        desconto: 4 + "%",
      },
    },
  },
  {
    condimentos: {
      fornecedorA: {
        minQuant: 500 + " Kg",
        precoBase: 95.0,
        leadTime: 7 + " Dias",
        atraso: 7 + " Dias",
        confiabilidade: 95 + "%",
        desconto: 0 + "%",
      },
      fornecedorB: {
        minQuant: 500 + " Kg",
        precoBase: 95.0,
        leadTime: 7 + " Dias",
        atraso: 14 + " Dias",
        confiabilidade: 80 + "%",
        desconto: 5 + "%",
      },
      fornecedorC: {
        minQuant: 15000 + " Kg",
        precoBase: 95.0,
        leadTime: 14 + " Dias",
        atraso: 14 + " Dias",
        confiabilidade: 70 + "%",
        desconto: 10 + "%",
      },
    },
  },
  {
    papelao: {
      fornecedorA: {
        minQuant: 24000 + " Milheiro",
        precoBase: 1.85,
        leadTime: 7 + " Dias",
        atraso: 7 + " Dias",
        confiabilidade: 95 + "%",
        desconto: 0 + "%",
      },
      fornecedorB: {
        minQuant: 24000 + " Milheiro",
        precoBase: 1.85,
        leadTime: 7 + " Dias",
        atraso: 14 + " Dias",
        confiabilidade: 80 + "%",
        desconto: 1 + "%",
      },
    },
  },

];
